import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_CONTACT_DATA_PROTECTION_LINK, GET_CONTACT_DATA_PROTECTION_LINK, GET_CONTACT_DATA_PROTECTION_LINK_BY_CONTACT_ID, GET_CONTACT_DATA_PROTECTION_LINKS, SAVE_CONTACT_DATA_PROTECTION_LINK } from "../../../data/definitions/data-protection.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { ContactDataProtectionLink, ContactDataProtectionLinkInput, DeleteContactDataProtectionLinkMutation, DeleteContactDataProtectionLinkMutationVariables, DeletionResponse, GetContactDataProtectionLinkByContactIdQuery, GetContactDataProtectionLinkByContactIdQueryVariables, GetContactDataProtectionLinkQuery, GetContactDataProtectionLinkQueryVariables, GetContactDataProtectionLinksQuery, GetContactDataProtectionLinksQueryVariables, SaveContactDataProtectionLinkMutation, SaveContactDataProtectionLinkMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class ContactDataProtectionLinkService extends BaseListService<ContactDataProtectionLink> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_CONTACT_DATA_PROTECTION_LINKS;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetContactDataProtectionLinksQuery, GetContactDataProtectionLinksQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetContactDataProtectionLinkQuery, GetContactDataProtectionLinkQueryVariables>(
      GET_CONTACT_DATA_PROTECTION_LINK, {
      id: id
    });
  }

  getItemByContactId(contactId: string) {
    return this.baseDataService.query<GetContactDataProtectionLinkByContactIdQuery, GetContactDataProtectionLinkByContactIdQueryVariables>(
      GET_CONTACT_DATA_PROTECTION_LINK_BY_CONTACT_ID, {
      contactId: contactId
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getContactDataProtectionLink);
  }

  async getItemData(id: string): Promise<ContactDataProtectionLink> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getContactDataProtectionLink as ContactDataProtectionLink;
  }

  async getItemDataByContactId(contactId: string): Promise<ContactDataProtectionLink> {
    let l = await lastValueFrom(this.getItemByContactId(contactId).single$);
    return l.getContactDataProtectionLinkByContactId as ContactDataProtectionLink;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {
    let res = await lastValueFrom(this.baseDataService.mutate<DeleteContactDataProtectionLinkMutation, DeleteContactDataProtectionLinkMutationVariables>(
      DELETE_CONTACT_DATA_PROTECTION_LINK, {
      id: id
    }));

    return res.deleteContactDataProtectionLink
  }

  async saveItem(item: ContactDataProtectionLink | ContactDataProtectionLinkInput) {

    let validated = await this.systemService.validateObject<ContactDataProtectionLinkInput>(
      item, "ContactDataProtectionLinkInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveContactDataProtectionLinkMutation, SaveContactDataProtectionLinkMutationVariables>(
      SAVE_CONTACT_DATA_PROTECTION_LINK, {
      input: validated
    }));

    return saved.saveContactDataProtectionLink as ContactDataProtectionLink;
  }
  //#endregion

}
